/*
  NerdMatic — ricompensa visiva per soglia di carrello, sulla scheda prodotto.
  Task 5026 · riscritto il 15/09/2026.

  La carta entra girata, si volta in 3D, atterra con un'onda d'urto e uno
  scoppio di scaglie di foil che nascono sul suo perimetro. Poi il foil e la
  trama lenticolare seguono il puntatore, e su telefono il giroscopio.

  Ogni carta e' diversa: numero di serie ricavato dal token del carrello,
  illustrazione col prodotto appena aggiunto, nome di chi e' collegato, importo
  e data. Si scarica come PNG che ripete lo stesso disegno.

  Scatta solo sulle aggiunte fatte dalla scheda prodotto, una volta per fascia
  per sessione. Niente librerie esterne: il 3D lo fa il CSS, le particelle sono
  un canvas scritto a mano.

  Per provarla senza riempire il carrello: ?nm-lab=1 in coda all'indirizzo.
*/
(function () {
  'use strict';

  var host = document.getElementById('nm-reward');
  var configEl = document.getElementById('nm-reward-config');
  if (!host || !configEl) return;

  var cfg;
  try { cfg = JSON.parse(configEl.textContent) || {}; } catch (e) { return; }
  var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.amount - b.amount; });
  if (!tiers.length) return;

  var SEEN_KEY = 'nm:reward:seen';
  var COLORI = {
    rara:    { foil: ['#7a3200', '#FF6A00', '#ffa869', '#c04e00'], scaglie: ['#FF6A00', '#ffa869', '#ffd9b8', '#ffffff'] },
    ultra:   { foil: ['#2e0b66', '#7c3aed', '#c4a0ff', '#4c1d95'], scaglie: ['#7c3aed', '#a97cff', '#e9d5ff', '#ffffff'] },
    segreta: { foil: ['#3d2800', '#c99700', '#ffe9a3', '#FF6A00'], scaglie: ['#c99700', '#ffe9a3', '#FF6A00', '#ffffff'] }
  };

  var scena = host.querySelector('.nm-reward__scena');
  var carta = host.querySelector('[data-nm-carta]');
  var canvas = host.querySelector('.nm-reward__particelle');
  var srRegion = host.querySelector('.nm-reward__sr');
  var el = {
    titolo: host.querySelector('[data-nm-titolo]'),
    perc: host.querySelector('[data-nm-perc]'),
    seriale: host.querySelector('[data-nm-seriale]'),
    importo: host.querySelector('[data-nm-importo]'),
    data: host.querySelector('[data-nm-data]'),
    firma: host.querySelector('[data-nm-firma]'),
    nome: host.querySelector('[data-nm-nome]')
  };

  var ridotto = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
  var memoria = [];
  var timers = [];
  var rafId = null;
  var particelle = [];
  var stato = { fascia: null, importo: 0, seriale: '' };
  var elementoDiPartenza = null;

  // useGrouping esplicito: senza, su it-IT il browser scrive "1003,00 €"
  // invece di "1.003,00 €" (raggruppamento min2 predefinito)
  var eur = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', useGrouping: true });

  /* ---------- memoria ---------- */

  function viste() {
    try { return JSON.parse(sessionStorage.getItem(SEEN_KEY)) || []; } catch (e) { return memoria; }
  }
  function ricorda(k) {
    var l = viste();
    if (l.indexOf(k) === -1) l.push(k);
    memoria = l;
    try { sessionStorage.setItem(SEEN_KEY, JSON.stringify(l)); } catch (e) {}
  }
  function fasciaPer(tot) {
    var hit = null;
    for (var i = 0; i < tiers.length; i++) if (tot >= tiers[i].amount) hit = tiers[i];
    return hit;
  }
  function testiPer(k) {
    var e = document.querySelector('[data-nm-testi="' + k + '"]');
    if (!e) return null;
    try { return JSON.parse(e.textContent); } catch (err) { return null; }
  }

  /* ---------- il numero di serie: stabile per quel carrello ---------- */

  function numeroDiSerie(token) {
    var s = String(token || Date.now()), h = 0;
    for (var i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
    var n = (Math.abs(h) % 999) + 1;
    return 'N. ' + ('00' + n).slice(-3) + ' / ' + new Date().getFullYear();
  }

  function dataBreve() {
    var d = new Date();
    return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + String(d.getFullYear()).slice(-2);
  }

  /* ---------- particelle ---------- */

  function dimensionaCanvas() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.floor(window.innerWidth * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return ctx;
  }

  // il punto del perimetro della carta nella direzione data: le particelle
  // nate al centro coprivano il titolo proprio quando si legge
  function puntoSulBordo(r, ang) {
    var dx = Math.cos(ang), dy = Math.sin(ang);
    var hw = r.width / 2, hh = r.height / 2;
    var t = Math.min(
      Math.abs(dx) < 1e-4 ? Infinity : hw / Math.abs(dx),
      Math.abs(dy) < 1e-4 ? Infinity : hh / Math.abs(dy)
    );
    return { x: r.left + hw + dx * t, y: r.top + hh + dy * t };
  }

  function lanciaParticelle(key, intensita) {
    if (ridotto) return;
    intensita = intensita || 1;
    var ctx = dimensionaCanvas();
    // la prima ondata parte dal centro dello schermo: la carta non c'e' ancora
    var r = intensita < 1
      ? { left: window.innerWidth / 2 - 90, top: window.innerHeight / 2 - 126, width: 180, height: 252 }
      : carta.getBoundingClientRect();
    var tinte = (COLORI[key] || COLORI.rara).scaglie;
    var quante = Math.round((window.innerWidth < 600 ? 80 : 120) * intensita);

    particelle = [];
    for (var i = 0; i < quante; i++) {
      var ang = Math.random() * Math.PI * 2;
      var b = puntoSulBordo(r, ang);
      var forza = 3.4 + Math.random() * 9;
      var forma = Math.random();
      particelle.push({
        x: b.x, y: b.y,
        vx: Math.cos(ang) * forza,
        vy: Math.sin(ang) * forza - 2.4,
        r: 1.4 + Math.random() * 3.4,
        vita: 1,
        decadi: 0.008 + Math.random() * 0.014,
        rot: Math.random() * Math.PI,
        vrot: (Math.random() - 0.5) * 0.34,
        colore: tinte[(Math.random() * tinte.length) | 0],
        // tre forme invece di una: scaglia lunga, rombo, puntino
        forma: forma < 0.45 ? 'scaglia' : (forma < 0.78 ? 'rombo' : 'punto')
      });
    }

    if (rafId) cancelAnimationFrame(rafId);
    (function disegna() {
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      var vive = 0;
      for (var i = 0; i < particelle.length; i++) {
        var p = particelle[i];
        if (p.vita <= 0) continue;
        vive++;
        p.vx *= 0.985;
        p.vy = p.vy * 0.985 + 0.17;
        p.x += p.vx; p.y += p.vy;
        p.rot += p.vrot;
        p.vita -= p.decadi;

        ctx.save();
        ctx.globalAlpha = Math.max(0, p.vita);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.colore;
        if (p.forma === 'scaglia') {
          ctx.fillRect(-p.r * 0.6, -p.r * 2.4, p.r * 1.2, p.r * 4.8);
        } else if (p.forma === 'rombo') {
          ctx.beginPath();
          ctx.moveTo(0, -p.r * 1.6); ctx.lineTo(p.r, 0); ctx.lineTo(0, p.r * 1.6); ctx.lineTo(-p.r, 0);
          ctx.closePath(); ctx.fill();
        } else {
          ctx.beginPath(); ctx.arc(0, 0, p.r * 0.8, 0, Math.PI * 2); ctx.fill();
        }
        ctx.restore();
      }
      if (vive > 0) {
        rafId = requestAnimationFrame(disegna);
      } else {
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
        rafId = null;
      }
    })();
  }

  /* ---------- inclinazione ---------- */

  function applicaInclinazione(nx, ny) {
    host.style.setProperty('--nm-tilt-x', (nx * 13).toFixed(2));
    host.style.setProperty('--nm-tilt-y', (-ny * 10).toFixed(2));
    host.style.setProperty('--nm-foil-x', (nx * 26).toFixed(2));
    host.style.setProperty('--nm-foil-y', (ny * 26).toFixed(2));
    // l'ombra si sposta al contrario della luce: e' quello che fa sembrare
    // un oggetto appoggiato invece di un rettangolo disegnato
    host.style.setProperty('--nm-ombra-x', (-nx * 26).toFixed(1) + 'px');
    host.style.setProperty('--nm-ombra-y', (-ny * 20 + 26).toFixed(1) + 'px');
  }
  function inclina(e) {
    if (ridotto || !host.classList.contains('is-idle')) return;
    var r = scena.getBoundingClientRect();
    applicaInclinazione(((e.clientX - r.left) / r.width - 0.5) * 2, ((e.clientY - r.top) / r.height - 0.5) * 2);
  }
  function inclinaGiroscopio(e) {
    if (ridotto || !host.classList.contains('is-idle')) return;
    var nx = Math.max(-1, Math.min(1, (e.gamma || 0) / 32));
    var ny = Math.max(-1, Math.min(1, ((e.beta || 0) - 40) / 32));
    applicaInclinazione(nx, ny);
  }
  function azzeraInclinazione() {
    ['--nm-tilt-x', '--nm-tilt-y', '--nm-foil-x', '--nm-foil-y', '--nm-ombra-x', '--nm-ombra-y'].forEach(function (v) { host.style.removeProperty(v); });
  }

  /* ---------- la carta da scaricare: stesso disegno, personalizzata ---------- */

  // la texture del foil: l'URL sta nella variabile CSS messa dallo snippet
  function caricaTextura(nomeVar) {
    return new Promise(function (res) {
      var v = getComputedStyle(host).getPropertyValue(nomeVar).trim();
      var m = v.match(/url\(["']?([^"')]+)["']?\)/);
      if (!m) return res(null);
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { res(null); };
      im.src = m[1];
    });
  }

  function caricaArte() {
    return new Promise(function (res) {
      var img = host.querySelector('.nm-carta__arte');
      var src = img && (img.currentSrc || img.src);
      if (!src) return res(null);
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { res(null); }; // senza CORS si rinuncia all'arte, non al file
      im.src = src;
    });
  }

  function rettArrotondato(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  function testoAdattato(ctx, testo, max, peso, corpoIniziale, famiglia) {
    var c = corpoIniziale;
    do {
      ctx.font = peso + ' ' + c + 'px ' + famiglia;
      c -= 2;
    } while (ctx.measureText(testo).width > max && c > 10);
    return ctx.font;
  }

  // tinte chiare della finestra, le stesse del CSS
  var FINESTRA = { rara: ['#fff6ee', '#ffdcc0', '#ffb98a'], ultra: ['#faf6ff', '#e4d6ff', '#c3a6ff'], segreta: ['#fffdf4', '#ffeeba', '#ffcf6b'] };

  async function salvaCarta() {
    var L = 630, H = 880;
    var c = document.createElement('canvas');
    c.width = L; c.height = H;
    var ctx = c.getContext('2d');
    var tinte = (COLORI[stato.fascia] || COLORI.rara).foil;
    var chiare = FINESTRA[stato.fascia] || FINESTRA.rara;
    var SG = '"Space Grotesk", Inter, system-ui, sans-serif';
    var IN = 'Inter, system-ui, sans-serif';

    // fondo foil
    var g = ctx.createLinearGradient(0, 0, L, H);
    g.addColorStop(0, tinte[0]); g.addColorStop(0.38, tinte[1]);
    g.addColorStop(0.58, tinte[2]); g.addColorStop(1, tinte[3]);
    ctx.fillStyle = g;
    rettArrotondato(ctx, 0, 0, L, H, 34); ctx.fill();

    // il foil del cartoncino: la stessa texture del CSS, in color-dodge
    var foilImg = await caricaTextura('--nm-foil');
    if (foilImg) {
      ctx.save();
      rettArrotondato(ctx, 0, 0, L, H, 34); ctx.clip();
      ctx.globalCompositeOperation = 'color-dodge';
      ctx.globalAlpha = 0.26;
      var fs = Math.max(L, H) * 1.85 / Math.min(foilImg.width, foilImg.height);
      ctx.drawImage(foilImg, (L - foilImg.width * fs) / 2, (H - foilImg.height * fs) / 2,
                    foilImg.width * fs, foilImg.height * fs);
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
      ctx.restore();
    }

    // una cornice sola e filetti, come nel CSS: i pannelli annidati erano il
    // motivo per cui la carta sapeva di generico
    var m = 26;
    ctx.strokeStyle = 'rgba(255,255,255,.44)'; ctx.lineWidth = 2;
    rettArrotondato(ctx, m, m, L - m * 2, H - m * 2, 20); ctx.stroke();

    var pad = m + 24;
    var filetto = function (y) {
      ctx.strokeStyle = 'rgba(255,255,255,.28)'; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(pad, y); ctx.lineTo(L - pad, y); ctx.stroke();
    };

    // striscia in alto
    ctx.save();
    ctx.translate(pad + 6, m + 48); ctx.rotate(Math.PI / 4);
    ctx.fillStyle = '#fff'; ctx.fillRect(-5, -5, 10, 10);
    ctx.restore();
    ctx.textAlign = 'left'; ctx.fillStyle = '#fff';
    ctx.font = '800 19px ' + SG;
    ctx.fillText('NERDMATIC', pad + 20, m + 54);
    ctx.textAlign = 'right';
    ctx.font = '700 19px ' + IN;
    ctx.fillText(stato.seriale, L - pad, m + 54);
    filetto(m + 70);

    // LA FINESTRA: chiara, col prodotto in multiply
    var fx = pad, fy = m + 88, fw = L - pad * 2, fh = 440;
    var arte = await caricaArte();
    ctx.save();
    rettArrotondato(ctx, fx, fy, fw, fh, 8); ctx.clip();
    var gf = ctx.createLinearGradient(fx, fy, fx + fw * 0.3, fy + fh);
    gf.addColorStop(0, chiare[0]); gf.addColorStop(1, chiare[1]);
    ctx.fillStyle = gf; ctx.fillRect(fx, fy, fw, fh);

    if (arte) {
      var sc = Math.min(fw / arte.width, fh / arte.height) * 1.16;
      var aw = arte.width * sc, ah = arte.height * sc;
      ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(arte, fx + (fw - aw) / 2, fy + (fh - ah) / 2, aw, ah);
      ctx.globalCompositeOperation = 'source-over';
    }

    // dentro la finestra chiara il color-dodge saturerebbe a bianco: multiply
    if (foilImg) {
      ctx.globalCompositeOperation = 'multiply';
      ctx.globalAlpha = 0.3;
      var ws = Math.max(fw, fh) * 1.6 / Math.min(foilImg.width, foilImg.height);
      ctx.drawImage(foilImg, fx + (fw - foilImg.width * ws) / 2, fy + (fh - foilImg.height * ws) / 2,
                    foilImg.width * ws, foilImg.height * ws);
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    }
    var glitterImg = await caricaTextura('--nm-glitter');
    if (glitterImg) {
      ctx.globalCompositeOperation = 'color-dodge';
      ctx.globalAlpha = 0.6;
      for (var gy = fy; gy < fy + fh; gy += 210) {
        for (var gx = fx; gx < fx + fw; gx += 210) ctx.drawImage(glitterImg, gx, gy, 210, 210);
      }
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    }

    // LA FIRMA al centro dell'illustrazione, di traverso
    var firma = (el.firma.textContent || '').trim();
    if (firma) {
      ctx.save();
      ctx.translate(fx + fw / 2, fy + fh * 0.52);
      ctx.rotate(-7 * Math.PI / 180);
      ctx.textAlign = 'center';
      testoAdattato(ctx, firma, fw * 0.82, '700 italic', 54, SG);
      ctx.fillStyle = 'rgba(0,0,0,.34)';
      ctx.fillText(firma, 2, 3);
      ctx.fillStyle = '#fff';
      ctx.fillText(firma, 0, 0);
      var lw = ctx.measureText(firma).width;
      var gl = ctx.createLinearGradient(-lw / 2, 0, lw / 2, 0);
      gl.addColorStop(0, 'rgba(255,255,255,0)'); gl.addColorStop(0.22, 'rgba(255,255,255,.9)');
      gl.addColorStop(0.78, 'rgba(255,255,255,.9)'); gl.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.fillStyle = gl;
      ctx.fillRect(-lw / 2 + lw * 0.04, 12, lw, 3);
      ctx.restore();
    }
    ctx.restore();

    // il nome della rarita' sul foil, senza pannello
    ctx.textAlign = 'center'; ctx.fillStyle = '#fff';
    var titolo = (el.titolo.textContent || '').toUpperCase();
    testoAdattato(ctx, titolo, L - pad * 2 - 20, '800', 58, SG);
    ctx.fillText(titolo, L / 2, fy + fh + 68);

    var perc = el.perc.textContent || '';
    ctx.fillStyle = 'rgba(255,255,255,.95)';
    testoAdattato(ctx, perc, L - pad * 2 - 30, '600', 23, IN);
    ctx.fillText(perc, L / 2, fy + fh + 104);

    // il piede
    filetto(H - m - 52);
    ctx.font = '700 19px ' + SG;
    ctx.fillStyle = '#fff';
    ctx.textAlign = 'left';
    ctx.fillText((el.importo.textContent || '').toUpperCase(), pad, H - m - 22);
    ctx.textAlign = 'right';
    ctx.fillText((el.data.textContent || '').toUpperCase(), L - pad, H - m - 22);

    // JPEG e non PNG: il contenuto e' fotografico (foto prodotto piu' foil) e
    // in PNG la carta pesava 948 KB, troppi per un'immagine da condividere
    var nome = 'nerdmatic-' + (stato.fascia || 'carta') + '-' + stato.seriale.replace(/[^0-9]/g, '-').replace(/^-|-$/g, '') + '.jpg';
    try {
      if (c.toBlob) {
        c.toBlob(function (blob) {
          var url = URL.createObjectURL(blob);
          scarica(url, nome);
          setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
        }, 'image/jpeg', 0.9);
      } else {
        scarica(c.toDataURL('image/jpeg', 0.9), nome);
      }
    } catch (e) {
      var img = host.querySelector('.nm-carta__arte');
      if (img) img.remove();
      salvaCarta();
    }
  }

  function scarica(url, nome) {
    var a = document.createElement('a');
    a.href = url; a.download = nome;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
  }

  /* ---------- apertura e chiusura ---------- */

  function pulisciTimers() { timers.forEach(clearTimeout); timers = []; }

  function chiudi() {
    pulisciTimers();
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    var ctx = canvas.getContext('2d');
    if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    host.classList.remove('is-open', 'is-entra', 'is-atterra', 'is-lampo', 'is-firma', 'is-idle');
    host.setAttribute('aria-hidden', 'true');
    azzeraInclinazione();
    if (srRegion) srRegion.textContent = '';
    if (elementoDiPartenza && elementoDiPartenza.focus) {
      try { elementoDiPartenza.focus({ preventScroll: true }); } catch (e) {}
    }
    elementoDiPartenza = null;
  }

  function apri(key, dati) {
    var t = testiPer(key);
    if (!t) return;
    dati = dati || {};

    pulisciTimers();
    stato.fascia = key;
    stato.importo = dati.totale || 0;
    stato.seriale = numeroDiSerie(dati.token);
    elementoDiPartenza = document.activeElement;

    el.titolo.textContent = t.titolo || '';
    el.perc.textContent = t.perc || '';
    el.seriale.textContent = stato.seriale;
    el.importo.textContent = stato.importo ? eur.format(stato.importo) : '';
    el.data.textContent = dataBreve();

    host.setAttribute('data-fascia', key);
    host.setAttribute('aria-hidden', 'false');
    host.classList.remove('is-entra', 'is-atterra', 'is-lampo', 'is-firma', 'is-idle');

    if (srRegion) srRegion.textContent = [t.titolo, t.perc].filter(Boolean).join('. ');

    void host.offsetWidth;
    host.classList.add('is-open');

    if (ridotto) {
      host.classList.add('is-entra', 'is-atterra', 'is-firma', 'is-idle');
      adattaFirma();
      return;
    }

    // Le battute, in ordine. Arrivare tutto insieme in 0,92s dava la sensazione
    // di scatto; 2,3 secondi pero' sono troppi su un'aggiunta al carrello.
    // Stretto a 1,5: fra una battuta e l'altra restano 120-200ms, che si
    // percepiscono ancora come momenti distinti.
    //   120ms  i fuochi, sul buio, prima che compaia qualcosa. Partono dal
    //          centro dello schermo: la carta non c'e' ancora
    //   280ms  la carta sale restando di spalle (0,95s di keyframe)
    //  1040ms  atterra: onda d'urto e seconda ondata di scaglie
    //  1160ms  il lampo attraversa il foil
    //  1320ms  la firma compare e il tratto si tira
    //  1520ms  i pulsanti e l'inclinazione
    timers.push(setTimeout(function () { lanciaParticelle(key, 0.55); }, 120));
    timers.push(setTimeout(function () { host.classList.add('is-entra'); }, 280));
    timers.push(setTimeout(function () {
      host.classList.add('is-atterra');
      lanciaParticelle(key, 1);
    }, 1040));
    timers.push(setTimeout(function () { host.classList.add('is-lampo'); }, 1160));
    timers.push(setTimeout(function () { host.classList.add('is-firma'); adattaFirma(); }, 1320));
    timers.push(setTimeout(function () { host.classList.add('is-idle'); }, 1520));
  }

  /* ---------- il gancio sul carrello ---------- */

  function alCarrelloAggiornato(ev) {
    if (!ev) return;
    if (ev.source !== 'product-form' && ev.source !== 'product-bundle') return;
    var cart = ev.cart;
    if (!cart || typeof cart.total_price !== 'number') return;

    var totale = cart.total_price / 100;
    var fascia = fasciaPer(totale);
    if (!fascia) return;
    if (viste().indexOf(fascia.key) !== -1) return;

    ricorda(fascia.key);
    apri(fascia.key, { totale: totale, token: cart.token });
  }

  function collega() {
    if (!window.theme || !window.theme.pubsub || !window.theme.pubsub.PUB_SUB_EVENTS) return false;
    window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, alCarrelloAggiornato);
    return true;
  }

  /* ---------- pannello di prova ---------- */

  function pannelloDiProva() {
    if (!/[?&]nm-lab=1/.test(location.search)) return;
    var box = document.createElement('div');
    box.className = 'nm-lab';
    box.innerHTML =
      '<span class="nm-lab__titolo">Prova ricompense</span>' +
      '<div class="nm-lab__riga">' +
        '<button type="button" data-f="rara">Rara</button>' +
        '<button type="button" data-f="ultra">Ultra</button>' +
        '<button type="button" data-f="segreta">Segreta</button>' +
      '</div>' +
      '<span class="nm-lab__nota">Importo e numero di serie sono finti qui: dal carrello vero arrivano quelli dell\'ordine.</span>';
    document.body.appendChild(box);

    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-f]');
      if (!b) return;
      var f = b.dataset.f;
      var soglia = (tiers.filter(function (t) { return t.key === f; })[0] || {}).amount || 250;
      chiudi();
      setTimeout(function () {
        apri(f, { totale: soglia + Math.round(Math.random() * 90), token: 'lab-' + f + '-' + Date.now() });
      }, 90);
    });
  }

  /* ---------- avvio ---------- */

  if (!collega()) document.addEventListener('DOMContentLoaded', collega, { once: true });

  host.addEventListener('click', function (e) {
    if (e.target.closest('[data-nm-salva]')) { salvaCarta(); return; }
    if (e.target.closest('[data-nm-chiudi]')) { chiudi(); return; }
  });

  // la firma finisce solo nell'immagine: non viene mandata da nessuna parte
  // Il corpo della firma lo decide la misura del testo: un nome lungo prima
  // sbordava dalla finestra. Parte da 26px e scende finche' non entra.
  function adattaFirma() {
    if (!el.firma) return;
    if (!(el.firma.textContent || '').trim()) return;
    var limite = el.firma.parentElement.clientWidth * 0.86;
    if (!limite) return;
    var corpo = 26;
    el.firma.style.setProperty('--nm-firma-corpo', corpo + 'px');
    for (var i = 0; i < 40 && corpo > 10; i++) {
      if (el.firma.scrollWidth <= limite) break;
      corpo -= 0.5;
      el.firma.style.setProperty('--nm-firma-corpo', corpo + 'px');
    }
  }

  if (el.nome) {
    el.nome.addEventListener('input', function () {
      el.firma.textContent = el.nome.value.trim();
      adattaFirma();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (host.classList.contains('is-open') && e.key === 'Escape') chiudi();
  });

  // Qualunque cosa il cliente faccia fuori dalla carta la congeda, e l'evento
  // arriva comunque alla pagina: il carrello dietro resta usabile.
  function fuoriDallaCarta(e) {
    if (!host.classList.contains('is-idle')) return;
    var t = e.target;
    if (t && t.closest && (t.closest('.nm-reward__scena') || t.closest('.nm-reward__azioni'))) return;
    chiudi();
  }
  document.addEventListener('pointerdown', fuoriDallaCarta, true);
  window.addEventListener('wheel', fuoriDallaCarta, { passive: true });
  window.addEventListener('touchmove', fuoriDallaCarta, { passive: true });

  scena.addEventListener('pointermove', inclina);
  scena.addEventListener('pointerleave', azzeraInclinazione);
  if (window.DeviceOrientationEvent) window.addEventListener('deviceorientation', inclinaGiroscopio);
  window.addEventListener('resize', function () { if (rafId) dimensionaCanvas(); });

  // Sul tema in anteprima Shopify inietta la sua barra in fondo allo schermo,
  // che coprirebbe i pulsanti proprio a chi sta revisionando il lavoro.
  function alzaSullaBarraDiAnteprima() {
    if (document.querySelector('#preview-bar-iframe, .shopify-preview-bar')) {
      host.classList.add('is-anteprima');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      pannelloDiProva();
      alzaSullaBarraDiAnteprima();
    }, { once: true });
  } else {
    pannelloDiProva();
    alzaSullaBarraDiAnteprima();
  }
  // la barra arriva dopo il primo paint
  setTimeout(alzaSullaBarraDiAnteprima, 1500);
})();
